import { Btn, Card } from "components/ui/index";
import { T } from "theme/index";

// ── Backup & Restore ──────────────────────────────────────────────────────────
export default function Backup({ transactions, wallets, investments, investmentSales = [], budgets, onExport, onImport, userEmail, onLogout, saving }) {
  const stats = [
    ["Transaksi", transactions.length, "💳", T.blue],
    ["Rekening",  wallets.length,      "👛", T.green],
    ["Investasi", investments.length,  "📈", T.gold],
    ["Anggaran",  budgets.length,      "🎯", T.purple],
    ["Jual",      investmentSales.length, "💰", T.orange],
  ];
  return (
    <div style={{ maxWidth:640 }}>
      {/* Account */}
      <Card style={{ padding:18, marginBottom:16 }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" }}>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <div style={{ width:40, height:40, borderRadius:10, background:T.gold+"20", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>👤</div>
            <div>
              <div style={{ color:T.text, fontWeight:700, fontSize:13 }}>{userEmail}</div>
              <div style={{ color:saving?T.gold:T.green, fontSize:11, marginTop:2, display:"flex", alignItems:"center", gap:5 }}>
                <span style={{ width:6, height:6, borderRadius:"50%", background:saving?T.gold:T.green }} />
                {saving ? "Menyimpan ke cloud..." : "Tersimpan & ter-sync"}
              </div>
            </div>
          </div>
          <Btn variant="danger" onClick={onLogout} style={{ fontSize:13 }}>Keluar</Btn>
        </div>
      </Card>
      {/* Current data summary */}
      <Card style={{ padding:18, marginBottom:16 }}>
        <div style={{ color:T.text, fontWeight:700, fontSize:14, marginBottom:14 }}>📦 Data Tersimpan</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(72px, 1fr))", gap:10 }}>
          {stats.map(([label, count, icon, col]) => (
            <div key={label} style={{ background:col+"10", border:`1px solid ${col}22`, borderRadius:10, padding:"12px 10px", textAlign:"center" }}>
              <div style={{ fontSize:20, marginBottom:4 }}>{icon}</div>
              <div style={{ color:col, fontWeight:800, fontSize:20, fontFamily:"monospace" }}>{count}</div>
              <div style={{ color:T.muted, fontSize:10, marginTop:2 }}>{label}</div>
            </div>
          ))}
        </div>
      </Card>

      {/* Export */}
      <Card style={{ padding:18, marginBottom:14 }}>
        <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
          <div style={{ width:44, height:44, borderRadius:11, background:T.green+"18", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, flexShrink:0 }}>📤</div>
          <div style={{ flex:1 }}>
            <div style={{ color:T.text, fontWeight:700, fontSize:14 }}>Export Data</div>
            <div style={{ color:T.muted, fontSize:12, marginTop:4, lineHeight:1.6 }}>Download seluruh data sebagai file JSON. Simpan ke Google Drive atau folder lokal sebagai backup.</div>
            <Btn onClick={onExport} variant="primary" style={{ marginTop:12 }}>📥 Download Backup (.json)</Btn>
          </div>
        </div>
      </Card>

      {/* Import */}
      <Card style={{ padding:18, marginBottom:14 }}>
        <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
          <div style={{ width:44, height:44, borderRadius:11, background:T.blue+"18", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, flexShrink:0 }}>📥</div>
          <div style={{ flex:1 }}>
            <div style={{ color:T.text, fontWeight:700, fontSize:14 }}>Import / Restore Data</div>
            <div style={{ color:T.muted, fontSize:12, marginTop:4, lineHeight:1.6 }}>Pulihkan data dari file backup. <span style={{ color:T.orange }}>Perhatian: ini akan mengganti semua data yang ada sekarang.</span></div>
            <label style={{ display:"inline-flex", alignItems:"center", gap:6, marginTop:12, background:T.surface, color:T.text, border:`1px solid ${T.border}`, borderRadius:8, padding:"10px 16px", fontSize:13, fontWeight:700, cursor:"pointer", WebkitTapHighlightColor:"transparent" }}>
              📂 Pilih File Backup
              <input type="file" accept=".json,application/json" onChange={onImport} style={{ display:"none" }} />
            </label>
          </div>
        </div>
      </Card>

      {/* Tips */}
      <Card style={{ padding:16, background:T.gold+"08", border:`1px solid ${T.gold}22` }}>
        <div style={{ color:T.gold, fontWeight:700, fontSize:12, marginBottom:8 }}>💡 Tips Backup ke Google Drive</div>
        <div style={{ color:T.muted, fontSize:12, lineHeight:1.7 }}>
          1. Klik <span style={{ color:T.text }}>Download Backup</span> di atas<br/>
          2. Simpan file ke folder yang ter-sync Google Drive desktop, atau upload manual ke drive.google.com<br/>
          3. Lakukan rutin (misal tiap akhir bulan) agar data selalu aman
        </div>
      </Card>
    </div>
  );
}
